// Step 23 — contract uncertainties.
//
// Reads `detail.uncertainties` verbatim. Uncertainties are the AI
// drafter's honest admission of gaps a human must resolve — we never
// hide, summarise, or de-emphasise them.

import { AIEmpty, AISection } from "../AIPrimitives";
import { normalizeContractUncertainties } from "./helpers";

export default function AIContractUncertainties({ detail }) {
  const items = normalizeContractUncertainties(detail?.uncertainties);
  if (items.length === 0) {
    return (
      <AISection title="Osäkerheter">
        <AIEmpty
          title="Inga osäkerheter registrerade"
          hint={
            "Om utkastet är AI-genererat är detta ovanligt — vanligtvis " +
            "listar drafting-tjänsten allt den inte kunde lösa."
          }
        />
      </AISection>
    );
  }
  return (
    <AISection
      title="Osäkerheter"
      right={
        <span className="qai-page-section-hint">
          {items.length} post{items.length === 1 ? "" : "er"} — kräver mänskligt beslut
        </span>
      }
    >
      <ul className="qai-contract-uncertainties">
        {items.map((u) => (
          <li key={u.key} className="qai-contract-uncertainty">
            <div className="qai-contract-uncertainty-label">{u.label}</div>
            {u.detail && (
              <div className="qai-contract-uncertainty-detail">{u.detail}</div>
            )}
          </li>
        ))}
      </ul>
    </AISection>
  );
}
